import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';

import DemoGymPageHeader from './components/DemoGymPageHeader';
import DemoGymTableContainer from './components/DemoGymTableContainer';
import { SearchFilters } from './components/types';

const DemoGymsPage = (): JSX.Element => {
  const [searchFilters, setSearchFilters] = useState<SearchFilters>({
    search: '',
    type: 'TIME_LIMITED',
  });
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);

  return (
    <>
      <DemoGymPageHeader searchFilters={searchFilters} setSearchFilters={setSearchFilters} />
      <DemoGymTableContainer searchFilters={debouncedSearchFilters} />
    </>
  );
};

export default DemoGymsPage;
